import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ErrorBoundary from "~/components/ErrorBoundry";
import { AdditionalBillingInfo } from "~/components/Subscription/AdditionalBillingInfo";
import SubscriptionPlanDetails from "~/components/Subscription/SubscriptionPlanDetails/SubscriptionPlanDetails";
import { fetchAccountSettings } from "~/store/actions/actions.accountSettings";
import { fetchBillingPaymentMethod } from "~/store/actions/actions.billingPaymentMethod";
import { fetchRecordedBalance } from "~/store/actions/actions.subscriptionBalance";
import SubscriptionLayout from "./Layout";

export const SubscriptionPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBillingPaymentMethod());
    dispatch(fetchAccountSettings());
    dispatch(fetchRecordedBalance());
  }, [dispatch]);

  return (
    <ErrorBoundary errorLocation="SubscriptionPage">
      <SubscriptionLayout
        pageTitle={t("Billing")}
        headerTitle={t("Billing")}
        renderFooter
      >
        <SubscriptionPlanDetails />
        <AdditionalBillingInfo />
      </SubscriptionLayout>
    </ErrorBoundary>
  );
};

export default SubscriptionPage;
